<template>
  <div style="width:730px;margin:0 auto">
      <div>
        <h1>全民反诈首都无诈公益宣传</h1>
    </div>
    <p>
        <video-player  class="video-player vjs-custom-skin"
     ref="videoPlayer1"
     :playsinline="true"
     :options="playerOptions1"
></video-player>

        <!-- <iframe height="498" width="710" src="https://player.youku.com/embed/XNTgzNzQzMTAxMg==" frameborder="0"></iframe> -->
    </p>
    <p>
        <video-player  class="video-player vjs-custom-skin"
     ref="videoPlayer2"
     :playsinline="true"
     :options="playerOptions2"
></video-player>
        <!-- <iframe height="498" width="710" src="https://player.youku.com/embed/XNTgzNzgyOTc4OA==" frameborder="0"></iframe>    -->
    </p>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
// require('vue-video-player/node_modules/video.js/dist/video-js.css')

export default {
  data() {
    return {
      playerOptions1: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: "https://images.qschou.com/mv/1.mp4", // 路径
            type: "video/mp4", // 类型
          },

        ],
        poster: "https://images.qschou.com/mv/1.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      playerOptions2: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: "https://images.qschou.com/mv/2.mp4", // 路径
            type: "video/mp4", // 类型
          },

        ],
        poster: "https://images.qschou.com/mv/2.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  components: {
    videoPlayer,
  },
};
</script>

<style>
    .video-js .vjs-big-play-button{
        left:50%;
        top:50%;
        margin-left:-45px;
        margin-top:-20px;
    }
</style>
